import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { styled } from '@noshiro/goober';
import { memoNamed } from '@noshiro/preact-utils';
import { MuiCard, MuiCardContent, MuiDivider, MuiTypography } from '../mui';
export const ProductsElementView = memoNamed('ProductsElementView', ({ link, title, subtitle, description, implementation, imageUrl }) => (_jsx(CardStyled, { children: _jsxs(CardContentStyled, { children: [_jsx(MuiTypography, Object.assign({ variant: 'title' }, { children: link === '' ? (_jsx("span", { children: title })) : (_jsx("a", Object.assign({ href: link, rel: 'noopener noreferrer', target: '_blank' }, { children: title }))) })), _jsx(MuiTypography, Object.assign({ variant: 'subtitle1' }, { children: subtitle })), _jsx(MuiDivider, {}), _jsxs(BodyWrapper, { children: [_jsx(MuiTypography, Object.assign({ variant: 'body1' }, { children: description })), _jsx(MuiTypography, Object.assign({ variant: 'body2' }, { children: `［実装］：${implementation}` }))] }), imageUrl === '' ? undefined : (_jsx(ImgStyled, { alt: imageUrl, src: imageUrl }))] }) })));
const CardStyled = styled(MuiCard) `
  margin: 10px;
  display: flex;

  flex-direction: row;
`;
const CardContentStyled = styled(MuiCardContent) `
  flex: auto;
  overflow: auto;
`;
const ImgStyled = styled('img') `
  max-height: 300px;
  max-width: min(480px, 100%);
  object-fit: contain;

  filter: drop-shadow(2px 4px 4px rgba(0, 0, 0, 0.25));
`;
const BodyWrapper = styled('div') `
  margin: 10px 0;
  white-space: pre-wrap;
`;
